import { medstarEntities } from '../../../../commons/services/lookups';
import { FieldValidationErrorMsg, RequiredAsterisk } from '../../atoms/form';

export default function MedstarEntitiesDropdown({ register, errors, showIsRequired }) {
  return (
    <div className='form-group'>
      <label htmlFor='medstarEntity'>MedStar Health entity</label>
      {showIsRequired && <RequiredAsterisk />}
      <select id='medstarEntity' className='form-control' {...register('medstarEntity')}>
        <option value='-1'>Choose...</option>
        {medstarEntities.map((medstarEntitiesDuplex) => {
          return (
            <option key={medstarEntitiesDuplex[0]} value={medstarEntitiesDuplex[0]}>
              {medstarEntitiesDuplex[1]}
            </option>
          );
        })}
      </select>
      <FieldValidationErrorMsg field='medstarEntity' errors={errors} />
    </div>
  );
}
